import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDuckduckgoComponent } from './simple-icons-duckduckgo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDuckduckgoComponent ],
    exports:      [ SimpleIconsDuckduckgoComponent ],
    bootstrap:    []
})
export class SimpleIconsDuckduckgoModule {}
